module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.5@core-js/library/modules/_add-to-unscopables.js
// module id = 384
// module chunks = 0 1